import React, { useEffect, useState } from 'react'

import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCInfoColor,
  $DCInfoLightColor,
  $DCprimaryColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  DcButton,
  DcTag,
  PixelDate,
  PixelModal,
  PixelTable,
  PixelTableAction,
  Section,
  SectionActions,
} from 'pixel-base'
import { env } from 'shared/env'
import { get } from 'utils/api-routes.util'
import PrintIcon from 'utils/icons/print-icon'

import AddBalance from './AddBalance'

const baseURL = env.SERVER_ADDR

const actions = [
  {
    title: 'Print',
    icon: (
      <Section>
        <PrintIcon color={$DCprimaryColor} size={18} />
      </Section>
    ),
    clickHandler: (d) => {
      const { token } = JSON.parse(
        localStorage.getItem('user_info') || '{token: null}',
      )
      window.open(
        `${baseURL}api/v2/print/billing/invoice/${token}/${d.billing_invoice_id}`,
      )
    },
  },
]
const columns = [
  {
    dataKey: 'created_at',
    name: 'Date',
    selector: (row) =>
      row.created_at.date ? <PixelDate value={row.created_at.date} /> : '--',
  },
  {
    dataKey: 'balance_requested',
    name: 'Balance Requested',
    isSortable: true,
    selector: (row) => (row.balance_requested ? row.balance_requested : '--'),
  },
  {
    dataKey: 'balance_granted',
    name: 'Balance Granted',
    isSortable: true,
    selector: (row) => (row.balance_granted ? row.balance_granted : '--'),
  },
  {
    dataKey: 'balance_available',
    name: 'Available Balance',
    isSortable: true,
    selector: (row) => (row.balance_available ? row.balance_available : '--'),
  },
  {
    dataKey: 'balance_status',
    name: 'Balance Status',
    selector: (row) => (row.balance_status ? row.balance_status : '--'),
  },
  {
    dataKey: 'payment_status',
    name: 'Payment Status',
    isSortable: true,
    selector: (row) => (
      <DcTag
        customBackgroundColor={
          row.payment_status === 'paid'
            ? $DCSuccessLightColor
            : row.payment_status === 'unpaid'
            ? $DCDangerLightColor
            : $DCInfoLightColor
        }
        textColor={
          row.payment_status === 'paid'
            ? $DCSuccessColor
            : row.payment_status === 'unpaid'
            ? $DCDangerColor
            : $DCInfoColor
        }
      >
        paid
      </DcTag>
    ),
  },
  {
    dataKey: 'actions',
    name: 'Print',
    selector: (row) => <PixelTableAction row={row} action={actions} />,
  },
]

const Balance = () => {
  const [transactions, setTransactions] = useState<any>([])
  const [tableLoading, setTableLoading] = useState(true)
  const [addBalanceModal, setAddBalanceModal] = useState(false)
  const readData = () => {
    setTableLoading(true)
    get('/communication/credits/purchases').subscribe((res: any) => {
      setTableLoading(false)
      setTransactions(res.response.data || [])
    })
  }

  useEffect(() => {
    readData()
  }, [])
  return (
    <>
      {/* <PixelPageContainer> */}
      <SectionActions
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          // paddingRight: '20px',
          padding: '10px 0px',
        }}
      >
        <DcButton onClick={() => setAddBalanceModal(true)}>
          Add Balance
        </DcButton>
      </SectionActions>
      {/* <Section isMobile={isMobile}>
        <SectionContent> */}
      <PixelTable
        columns={columns}
        data={transactions || []}
        progressPending={tableLoading}
      />
      {/* </SectionContent>
      </Section> */}
      {/* </PixelPageContainer> */}
      {addBalanceModal && (
        <PixelModal
          title={'Add Balance'}
          handleClose={() => setAddBalanceModal(false)}
          show={addBalanceModal}
          size="lg"
        >
          {addBalanceModal && (
            <AddBalance
              setAddBalanceModal={setAddBalanceModal}
              handleClose={() => {
                readData()
                setAddBalanceModal(false)
              }}
            />
          )}
        </PixelModal>
      )}
    </>
  )
}
export default Balance
